// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","backtolive":"Footer_backtolive__TI5Kd","eventticker":"Footer_eventticker__wrZbf","mobilehelper":"Footer_mobilehelper__D3r8Q"};